import { GetOrderRequestsQueryParams, GetOrdersQueryParams, GetPendingOrdersQueryParams, Order } from '@/lib/Order/types';
import _ from 'lodash';
import { API } from './../Client';
import { OldAPI } from './../OldClient';
import { CreateOrderBody, CreateOrderResponse, OrderTimeInForce, OrderType, PendingOrders } from './types';

namespace OrderService {

  /**
     * Cancel an order request that is pending parental approval and delete all order request activities for this order request
     *
     * @param orderRequestId firebase order request ID
     */
  export async function cancelOrderRequest(orderRequestId: string): Promise<void> {
    await API.delete(`/trading/orders/requests/${orderRequestId}`);
  }

  /**
 * Create a 'buy' or 'sell' order (can be a crypto order as well)
 *
 * @param body order body (have to input EITHER notional OR qty, both together not allowed). 'qty' is not required if sellAll = true
 * @returns
 */
  export async function createOrder(body: CreateOrderBody): Promise<CreateOrderResponse> {
    const defaults = {
      type: OrderType.MARKET,
      time_in_force: OrderTimeInForce.DAY,
      tradeMode: "real",
      accountId: body.userId,
    };

    if (!!body.isCrypto) {
      defaults.time_in_force = OrderTimeInForce.IOC;
    }

    const res = await OldAPI.post(`/orders/request`, { ...defaults, ..._.omit(body, ['sellAll', 'isCrypto', 'userId']) }, {
      params: {
        isCrypto: !!body?.isCrypto,
        sellAll: !!body?.sellAll
      }
    });
    return res?.data;
  }

  /**
   * Cancels specified open order and deletes all scheduled activities for this order
   *
   * @param orderId alpaca order id
   */
  export async function cancelOrder(orderId: string): Promise<void> {
    await API.delete(`/trading/orders/${orderId}`);
  }

  /**
   * Fetches all orders of users
   * 
   * @param params query params
   * @returns 
   */
  export async function getOrders(params: GetOrdersQueryParams): Promise<Order[]> {
    const res = await API.get('/trading/orders', {
      params
    });
    return res?.data || [];
  };

  /**
  * Fetches all QUEUED approval status order requests of users
  * 
  * @param params query params
  * @returns 
  */
  export async function getOrderRequests(params: GetOrderRequestsQueryParams): Promise<Order[]> {
    const res = await API.get('/trading/orders/requests', {
      params
    });
    return res?.data || [];
  };

  /**
   * Fetches all pending orders (made outside of market hours) and order requests of user awaiting parent approval
   * 
   * @param userId 
   * @param alpacaId 
   * @returns 
   */
  export async function getPendingOrders(params: GetPendingOrdersQueryParams): Promise<PendingOrders> {
    // const { pendingOrders: existingPendingOrders } = portfolio;
    const res = await API.get('/trading/orders/pending', {
      params
    });

    return res?.data || [];

    //TODO: figure out why this is here and come back here
    // if (data?.length !== (existingPendingOrders?.length || 0)) {
    //   // load account then because something might have changed
    //   dispatch(loadAccount(null, true));
    //   dispatch(loadHistory());
    // }
  };

}

export default OrderService;
